import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

const handleError = (error) => {
  const message =
    error.response?.data?.message || error.message || "Unknown error";
  throw new Error(message);
};

export const apiClient = {
  get: async (url, config = {}) => {
    try {
      const { data } = await axiosInstance.get(url, config);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  post: async (url, body = {}, config = {}) => {
    try {
      const { data } = await axiosInstance.post(url, body, config);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  put: async (url, body = {}, config = {}) => {
    try {
      const { data } = await axiosInstance.put(url, body, config);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  patch: async (url, body = {}, config = {}) => {
    try {
      const { data } = await axiosInstance.patch(url, body, config);
      return data;
    } catch (error) {
      handleError(error);
    }
  },

  delete: async (url, config = {}) => {
    try {
      const { data } = await axiosInstance.delete(url, config);
      return data;
    } catch (error) {
      handleError(error);
    }
  },
};
